import { IComponentOptions, IController, IFormController } from 'angular';
import './public-additional-modal.component.scss';

export enum PublicModalTypes {
  COMMON = 1,
  ADVERTISING_MARKETING = 2,
  BUSINESS_CENTER = 3
}

export class PublicAdditionalModalController implements IController {
  static $inject = [];
  data: {
    modalType: PublicModalTypes
  };
  onClose: ( data ) => void;
  email: string;
  form: IFormController;

  constructor() {

  }

  closeModal() {
    this.onClose({ result: true });
  }

  submit() {
    if ( this.form.$invalid ) {
      return;
    }
    console.log(this.email);
    this.closeModal();
  }
}

export const PublicAdditionalModalComponent: IComponentOptions = {
  controller: PublicAdditionalModalController,
  template: require('./public-additional-modal.component.html'),
  bindings: {
    data: '<',
    onClose: '&'
  }
};



// WEBPACK FOOTER //
// ./app/states_mobile/public/components/public-additional-modal/public-additional-modal.component.ts